import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { BackToMenu } from "../features/menu/back-link";
import { ItemFormView } from "../features/menu/item-form";
import { useInPanes } from "../features/menu/panes";
import { Require } from "../features/require";

type Search = { category?: string };

export const Route = createFileRoute("/menu/items/new")({
	validateSearch: (search: Record<string, unknown>): Search =>
		typeof search.category === "string" ? { category: search.category } : {},
	component: Page,
});

function Page() {
	const { category } = Route.useSearch();
	const navigate = useNavigate();
	const inPanes = useInPanes();
	return (
		<Require permission="menu.edit">
			<div className="max-w-3xl">
				<ItemFormView
					itemId={null}
					categoryId={category ?? null}
					back={<BackToMenu />}
					onSaved={(item) =>
						void navigate(
							inPanes
								? {
										to: "/menu/items/$itemId",
										params: { itemId: item.id },
										search: { category: item.categoryId },
									}
								: { to: "/menu" },
						)
					}
					onDeleted={() => void navigate({ to: "/menu" })}
				/>
			</div>
		</Require>
	);
}
